export const dateService = {
    getDate,
    getDatetimeLocal,
    getMonth,
    getWeek
}

function getDateByText(text) {
    const now = new Date();

    if (!text)
        return null;

    let date = null;

    switch(text.toLowerCase()) { 
        case "today": { 
           date = now;
           break; 
        } 
        case "yesterday": { 
           now.setDate(now.getDate() - 1);
           date = now;
           break; 
        }
        case "tomorrow": { 
            now.setDate(now.getDate() + 1);
            date = now;
           break;    
        } 
        case "firstofyear": {
            date = new Date(now.getFullYear(), 0, 1);
            break;
        }
        case "lastofyear": { 
           date = new Date(now.getFullYear(), 11, 31, 23, 59, 59);
           break; 
        }  
        case "firstofmonth": {               
            date = new Date(now.getFullYear(), now.getMonth(), 1);
            break;
        }
        case "lastofmonth": {
            date = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59);
            break;
        }        
        default: {
            date = text;
            break;
        }
     } 

     return date;
}

function getDate(text) {
    const d = getDateByText(text);
    
    if (!d || typeof d === "string")
        return d;

    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

function getDatetimeLocal(text) {
    const d = getDateByText(text);
    
    if (!d || typeof d === "string")
        return d;

    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}T${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
}

function getMonth(text) {
    const d = getDateByText(text);
    
    if (!d || typeof d === "string")
        return d;

    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
}

function getWeek(text) {
    const d = getDateByText(text);
    
    if (!d || typeof d === "string")
        return d;
    
    var onejan = new Date(d.getFullYear(),0,1);    
    return `${d.getFullYear()}-W${Math.ceil((((d - onejan) / 86400000) + onejan.getDay()+1)/7)}`;
}